if (!customElements.get('qi-physical-gallery')) {
  customElements.define('qi-physical-gallery', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.select('image');
        this.setAttribute('data-ready', '');
        const thumbnails = this.querySelector('[data-qi-gallery-thumbnails]');
        if (thumbnails) thumbnails.hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-qi-gallery-select]');
          if (!button || button.closest('qi-physical-gallery') !== this) return;
          this.select(button.dataset.qiGallerySelect, true);
        }, { signal: this.controller.signal });
      });
    }

    select(name, play = false) {
      if (!['image', 'video'].includes(name)) return;
      this.querySelectorAll('[data-qi-gallery-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.qiGalleryPanel !== name;
      });
      this.querySelectorAll('[data-qi-gallery-select]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.qiGallerySelect === name));
      });
      const video = this.querySelector('video');
      if (!video) return;
      if (name === 'video' && play) {
        video.muted = true;
        const playback = video.play();
        if (playback) playback.catch(() => {});
      } else {
        video.pause();
      }
    }

    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
